// Signal emitted after any successful add/update/status/delete so other
// components (or the section itself) can trigger a refetch. Same pattern as
// the other v2 sections' events.js files.
export const ACT_V2_REFRESH = "act-v2:refresh";

/**
 * Open a sheet in the editor rail. ADD carries `{ existingList }`; EDIT
 * carries `{ activity, existingList }`. The list rides along because the
 * form's duplicate check runs on every keystroke against the CURRENT table,
 * and the rail has no list of its own — passing it at open time keeps it
 * fresh without a second GET.
 */
export const ACT_V2_ADD = "act-v2:add";
export const ACT_V2_EDIT = "act-v2:edit";
/**
 * Open the status-only Update sheet (board 3071:4666) in the same rail.
 * Carries `{ activity, mode: "status" }` — the mode marker is how the rail
 * tells a status sheet from a full edit, because both channels share one
 * listener. Dedup is by activityId across BOTH kinds: an edit sheet and a
 * status sheet for the same row would race each other's write.
 */
export const ACT_V2_STATUS = "act-v2:status";

/**
 * Transcript-mode re-edit of an already-staged captured item. Payload
 * `{ captured, actv2Record }` — actv2Record is null for a staged-add
 * row. Mirrors CC_V2_EDIT_CAPTURED / DX_V2_EDIT_CAPTURED.
 */
export const ACT_V2_EDIT_CAPTURED = "act-v2:edit-captured";
